<style lang="scss" scoped>
.font-weight {
    font-weight: 800;
}
.inbound-package {
	right: 10px;
	top: 3px;
}
.reciveoffer .ivu-table{
    font-size: 12px !important;
}
.reciveoffer .ivu-table-cell{
    padding-left: 5px !important;
    padding-right: 5px !important;
}
.reciveoffer td.ivu-table-expanded-cell{
    padding: 0px !important;
}
.reciveoffer td.ivu-table-expanded-cell{
    padding: 0px !important;
    border: none !important
}

.reciveoffer td.ivu-table-expanded-cell .ivu-table-wrapper-with-border{
    border: none !important
}
.reciveoffer .workitemtable .ivu-table-border td:last-child{
        border-right: none !important;
    }
</style>
<template>
    <div class="relative reciveoffer margin-top-10">
        <div style="display:flex;height: 300px">
            <compWrapper title="基本信息" :class="classes">
                <compFormEdit ref="relation" class="margin-layout" :formdata="getBase" v-model="formData" :labelWidth="120"/>
            </compWrapper>
            <compWrapper title="计费项目" style="width:30%;margin-left:10px" v-if="(formData.expenseCategoryType!=0)">
                <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll" style="padding-left:25%; margin:8px 0">全选</Checkbox>
                <CheckboxGroup v-if="this.type != 'query'" v-model="countDataList" @on-change="checkAllGroupChange" style="display:flex; flex-direction:column; align-items:flex-start; padding-left:25%; height:200px; overflow:auto">
                    <Checkbox v-for="(item,index) in countData" :key="index" :label="item.label" style="margin-bottom:8px"></Checkbox>
                </CheckboxGroup>

                <CheckboxGroup v-else v-model="countDataList" @on-change="checkqueryAllGroupChange" style="display:flex; flex-direction:column; align-items:flex-start; padding-left:25%; height:200px; overflow:auto">
                    <Checkbox v-for="(item,index) in countDataListQuery" :key="index" :label="item" style="margin-bottom:8px"></Checkbox>
                </CheckboxGroup>
            </compWrapper>
        </div>
        <!-- 价格列表 -->
        <compWrapper title="价格列表" >
            <!-- 针对仓储费展示提示 -->
            <!-- <Alert class="margin-15" v-if="formData.expenseCategoryType == 1" show-icon>
                仓储费原计费体积单位为立方英尺（包仓除外），自2023年1月12日开始切换为立方米，请检查并更新报价，2023年1月12日之前生成的费用如需按立方米结算，可手动重新结算。
            </Alert> -->
            <div v-show="(formData.expenseCategoryType == 0)" class="margin-15">
                <Button v-if="isShowDetail" @click="showDetail">全部展开</Button>
                <Button v-else @click="showDetail">全部折叠</Button>
            </div>
            <Table
            v-if="(formData.expenseCategoryType == 0)"
            style="z-index:2"
            class="margin-15 worktable"
            :columns="workcolumns"
            :data="workDataList"
            size="small"
            ref="tabledoc"
            max-height="500"
            :span-method="handleSpan"
            border></Table>

            <vTable
            v-else
            style="z-index:2"
            class="margin-15"
            :columns="columns"
            :data="newDatalist"
            max-height="500"
            size="small"
            ref="tabledoc"
            border></vTable>
        </compWrapper>
        <!-- 操作历史 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
            @on-close="closemodalprops"
		>
            <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" v-on="modalProps.on"></component>
        </compModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>

    </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";

import {
    HttpGetBillingUnit,
    HttpGetAllBillingCondition,
} from '@/service/bespeak';

import { HttpQueryReciveBase, HttpQueryRecivePrice,HttpSaveReciveTemplate,HttpGetAllValuationList,HttpGetCategoryType,HttpGetQuerySubByIds,HttpGetHistoryPriceItems} from "@/service/tasks";
import { HttpQueryBillRuleOne } from "@/service/newbigaccount";
import compLogVersion from '../payableoffer/logversion.vue'
import mixin from '../mixin';
export default {
    mixins: [mixin],
    props:['activeid','querytype','logversion','logcode'],
    data(){
        return {
            id:this.$route.query.id || this.activeid,
            type: this.$route.params.type || this.querytype,
            formData:{
                expenseCategoryType:-1,
            },
            modalProps:{
                show: false,
            },
            countData:[],
            countDataList:[],
            countDataListQuery:[],
            indeterminate: false,
            checkAll: false,
            logList:[],
            datalist:[],
            newDatalist:[],
            startAllTime: '',
            endAllTime: '',
            loading:false,
            showDate:'',
            billUnitEnum:[],
            billConditionEnum:[],
            valuationList:[],
            dataName:[],
            workDataList:[],
            isShowDetail:false,
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLogVersion,
	},
    created(){
        this.update();
        // 查询计费单位与附加条件
        HttpGetBillingUnit().then(res=>{
            Object.keys(res.data).forEach((key)=>{
                let jsonone = {
                    label:key,
                    value:res.data[key]
                }
                this.billUnitEnum.push(jsonone)
            })
        })
        HttpGetAllBillingCondition().then(res=>{
            this.billConditionEnum = res.data.map(item=>{
                return {
                    value:item.code,
                    label:item.name
                }
            })
        })
        HttpGetAllValuationList().then(res=>{
            this.valuationList = res.data.map(item=>{
                return {
                    value:item.id,
                    label:item.name+'('+item.code+')',
                    attach:{
                        code:item.code
                    }
                }
            })
        })


        this.showDate = this.type == 'edit' ? 'flex':'none';
    },
    watch :{
        'countDataList': {
            handler(val) {
                this.changeNewDatalist(val);
            },
        }
    },
    computed:{
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        ...mapGetters('common', ['getCurrencyList']),
        classes(){
            return {
                'width-100per':this.formData.expenseCategoryType==0,
                'width-70per':this.formData.expenseCategoryType!=0
            }
        },
        getBase(){
            return [
                {
					label: "模板代码",
					key: "code",
                    query:this.type!='add',
				},
                {
					label: "模板名称",
					key: "name",
                    query:this.type=='query',
				},
                {
                    label: "费用类型",
                    tag:'Select',
                    key:'expenseCategoryType',
                    options:this.getCusBillTypeList,
                    query:this.type!='add',

                },
                {
                    label: "状态",
                    tag:'Select',
                    key:'status',
                    options:[
                        {value:0,label:'禁用'},
                        {value:1,label:'启用'},
                    ],
                    query:this.type!='add',

                },
                {
                    label: "计价方案",
                    tag:'Select',
                    key:'billingPlanId',
                    options:this.valuationList,
                    query:this.type!='add',
                    show:this.formData.expenseCategoryType == 0,
                },
                {
                    label: "版本号",
                    tag:'Input',
                    key:'version',
                    query:this.type!='add',

                },
                {
                    label: "备注",
                    tag:'Input',
                    key:'description',
                    query:this.type=='query',

                },


            ]
        },
        columns(){
            let _this = this;
            return [
                {
                    title: 'code',
                    key: 'billingCategoryCode',
                },{
                    title: '计费项目',
                    key: 'billingCategoryName'
                }, {
                    title: '计费单位',
                    key: 'billingUnit',
                    render:(h,{ row, index })=>{
                        return <div>{this.getbillingUnit(row.billingUnit)}</div>
                    }

                }, {
                    title: '名称',
                    key:'description',
                },{
                    title: '规则分组',
                    key:'groupName',
                },
                {
                    title: '约束条件',
                    // key: 'billingCondition',
                    render:(h,{ row, index })=>{
                        if(row.billingCondition){
                            if(row.billingUnit == 900){
                                return <div>{row.billingCondition}</div>
                            }else{
                                return <div>{this.getbillConditionEnum(row.billingCondition) || '--' }</div>
                            }
                        }else{
                            return <div>--</div>
                        }
                    }

                },
                {
                    title: '公式',
                    key: 'billingCategoryFormula',
                    render:(h,{ row, index })=>{
                        return <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><Tooltip content={row.billingCategoryFormula}>{row.billingCategoryFormula}</Tooltip></div>
                    }
                },
                {
                    width:this.formData.expenseCategoryType == 3 ? 'auto':0,
                    title: '计费公式',
                    render:(h,{ row, index })=>{
                        if(this.type == 'query' ){
                            return <div>{row.formula}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.formula
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'formula',event)
                                    }
                                },
                            })
                        }
                    },
                },
                {
                    width:this.formData.expenseCategoryType == 1 ? 'auto':0,
                    title: '存储天数起',
                    render:(h,{ row, index })=>{
                        return <div>{row.attachValue}</div>
                    },
                },
                {
                    width:this.formData.expenseCategoryType == 1 ? 'auto':0,
                    title: '存储天数止',
                    render:(h,{ row, index })=>{
                        return <div>{row.attachValue1}</div>
                    },
                },

                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.price}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.price
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'price',event)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.minimumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.minimumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'minimumCharge',event)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.maximumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.maximumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        this.setValue(row,'maximumCharge',event)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('vDatepicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'datetime',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        format:'yyyy-mm-dd',
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                    'on-change':function(date,value){
                                        _this.startAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      type: "gray",
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setStartTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.startTime}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    // clearable:true,

                                    format:'yyyy-mm-dd',
                                    confirm: false,
                                    // value:_this.datalist[index].startTime
                                    value:  _this.datalist.filter(item => item.billingCategoryCode == row.billingCategoryCode)[0].startTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        // console.log(date,value,'startTime')
                                        _this.datalist.filter(item => {
                                            if(item.billingCategoryCode == row.billingCategoryCode){
                                                item.startTime = date
                                            }
                                        })
                                        // _this.datalist[index].startTime = date
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    // title: "失效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('vDatepicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'datetime',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        format:'yyyy-mm-dd',
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.endAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setEndTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.endTime}</div>
                        }else{
                            return h('vDatepicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'datetime',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    // clearable:true,

                                    format:'yyyy-mm-dd',
                                    confirm: false,
                                    // value:_this.datalist[index].endTime
                                    value:  _this.datalist.filter(item => item.billingCategoryCode == row.billingCategoryCode)[0].endTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        _this.datalist.filter(item => {
                                            if(item.billingCategoryCode == row.billingCategoryCode){
                                                item.endTime = date
                                            }
                                        })
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title:'创建人',
                    width: this.type == 'query' ? 60 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.createdName}</div>
                    }
                },
                {
                    title:'创建时间',
                    width: this.type == 'query' ? 75 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.createdAt}</div>
                    }
                },
                {
                    title:'更新人',
                    width: this.type == 'query' ? 60 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.updatedName}</div>
                    }
                },
                {
                    title:'更新时间',
                    width: this.type == 'query' ? 75 : 0,
                    render:(h,{ row })=>{
                        return <div>{row.updatedAt}</div>
                    }
                },
            ]
        },
        workcolumns(){
            let _this = this;
            let worklist = [
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, {row}) => {
                            return <Table border class="font-12 workitemtable" columns={this.workItemcolumns} show-header={false} data={row.childrenArr||[]}></Table>
                        }
                    },

                {
                    title: '单据类型',
                    key: 'orderType',
                    render:(h,{row})=>{
                        let name = this.getOrderList.find( obj => obj.value === row.orderType)
                        return <div>{name.label}</div>
                    }
                },
                {
                    title: 'code/计费项目',
                    key: 'billingCategoryCode',
                    width:100,
                    render:(h,{row})=>{
                        return <div></div>
                    }
                }, {
                    title: '计费单位',
                    key: 'billingUnit',
                    render:(h,{ row, index })=>{
                        return <div></div>
                    }

                }, {
                    title: '名称',
                    key:'description',
                },{
                    title: '规则分组',
                    key:'groupName',
                },
                {
                    title: '约束条件/公式',
                    width:100,
                    render:(h,{ row, index })=>{
                        return <div></div>
                    }
                },
                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        return <div>{row.price}</div>
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        return <div>{row.minimumCharge}</div>
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        return <div>{row.maximumCharge}</div>
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('DatePicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'date',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                    'on-change':function(date,value){
                                        _this.startWorkAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      type: "gray",
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setWorkStartTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        return <div>{row.startTime}</div>
                    }
                },
                {
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期'),
                            h('div',{
                                style:{
                                    'display': this.showDate,
                                    'flex-direction': 'column',
                                    'justify-content': 'space-around',
                                    'align-items': 'flex-start'
                                }
                            },[
                                h('DatePicker',{
                                    props:{
                                        transfer:true,
                                        placement:'top',
                                    },
                                    attrs: {
                                        placement:'top',
                                        type:'date',
                                        style:'width:100%',
                                        placeholder:"Select date",
                                        clearable:true,
                                        confirm: false,
                                    },
                                    style:{
                                        'margin-top': '5px'
                                    },
                                    on: {
                                        'on-change':function(date,value){
                                            _this.endWorkAllTime = date;
                                    },
                                },
                                }),
                                h('Button', {
                                    props: {
                                      size: 'small',
                                    },
                                    on: {
                                      click: this.setWorkEndTime
                                    },
                                    style: {
                                        'margin-top': '5px'
                                    }
                                }, '批量设置')
                            ])
                        ])
                    },
                    render:(h,{ row, index })=>{
                        return <div>{row.endTime}</div>
                    }
                },
                {
                    title:'创建人/创建时间',
                    width: this.type == 'query' ? 100 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.createdName}
                            <div>{row.createdAt}</div>
                        </div>
                    }
                },
                {
                    title:'更新人/更新时间',
                    width: this.type == 'query' ? 100 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.updatedName}
                            <div>{row.updatedAt}</div>
                        </div>
                    }
                },
            ]
            if(this.type!='query'){
                return worklist.splice(0,12)
            }else{
                return worklist
            }
        },
        workItemcolumns(){
            let _this = this;
            let workitemlist = [
                    {
                        type: 'index',
                        width: 50,
                        align:'center',
                    },
                {
                    title: '单据类型',
                    key: 'orderType',
                    render:(h,{row})=>{
                        return <div></div>
                    }
                },
                {
                    title: 'code/计费项目',
                    key: 'billingCategoryCode',
                    width:100,
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.billingCategoryCode || '--'}</div>
                            <div>{row.billingCategoryName || '--'}</div>
                        </div>
                    }
                }, {
                    title: '计费单位',
                    key: 'billingUnit',
                    render:(h,{ row, index })=>{
                        return <div>{this.getbillingUnit(row.billingUnit)}</div>
                    }

                }, {
                    title: '名称',
                    key:'description',
                },{
                    title: '规则分组',
                    key:'groupName',
                },
                {
                    title: '约束条件/公式',
                    width:100,
                    render:(h,{ row, index })=>{
                        let tiaojian;
                        if(row.billingCondition){
                            if(row.billingUnit == 900){
                                tiaojian = row.billingCondition
                            }else{
                                tiaojian = this.getbillConditionEnum(row.billingCondition) || '--'
                            }
                        }else{
                            tiaojian = '--'
                        }
                        return <div>
                            {tiaojian}
                            <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><Tooltip content={row.billingCategoryFormula}>{row.billingCategoryFormula || '--'}</Tooltip></div>
                        </div>
                    }
                },
                {
                    title:'单价',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query' || row.itemquery == 'query'){
                            return <div>{row.price}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.price
                                },
                                on: {
                                    'input':(event) => {
                                        row.price = event
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最低收费',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query' || row.itemquery == 'query'){
                            return <div>{row.minimumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.minimumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        row.minimumCharge = event
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title:'最高收费',
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query' || row.itemquery == 'query'){
                            return <div>{row.maximumCharge}</div>
                        }else{
                            return h('vInput',{
                                props: {
                                    size:'small',
                                    value:row.maximumCharge
                                },
                                on: {
                                    'input':(event) => {
                                        row.maximumCharge = event
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    // title: "生效日期",
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','生效日期'),
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.startTime}</div>
                        }else{
                            return h('DatePicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'date',
                                    style:'width:100%',
                                    placeholder:"Select date",
                                    confirm: false,
                                    // value:_this.datalist[index].startTime
                                    value:  row.startTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        console.log(date,'adadada')
                                        row.startTime = date
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })
                                    },
                                },
                            })
                        }
                    }
                },
                {
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('strong','失效日期')
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.endTime}</div>
                        }else{
                            return h('DatePicker',{
                                props:{
                                    transfer:true,
                                    placement:'top',
                                },
                                attrs: {
                                    placement:'top',
                                    type:'date',
                                    style:'width:100%',
                                    placeholder:"Select date",

                                    confirm: false,
                                    value:  row.endTime
                                },
                                on: {
                                    'on-change':function(date,value){
                                        row.endTime = date
                                        _this.workDataList.map((item,aindex)=>{
                                            if(row.orderType == item.orderType){
                                                _this.workDataList[aindex].childrenArr[index] = row
                                            }
                                        })                                    },
                                },
                            })
                        }
                    }
                },
                {
                    title:'创建人/创建时间',
                    width: this.type == 'query' ? 100 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.createdName}
                            <div>{row.createdAt}</div>
                        </div>
                    }
                },
                {
                    title:'更新人/更新时间',
                    width: this.type == 'query' ? 100 : 0,
                    render:(h,{ row })=>{
                        return <div>
                            {row.updatedName}
                            <div>{row.updatedAt}</div>
                        </div>
                    }
                },
            ]
            if(this.type!='query'){
                return workitemlist.splice(0,12)
            }else{
                return workitemlist
            }
        }
    },
    methods:{
        closemodalprops(){
            this.$emit('on-openCloseable');
            // this.modalProps = {};
        },
        async showDetail(){
            this.loading = true;
            await setTimeout(()=>{
                this.workDataList.map(item=>{
                    item._expanded = !item._expanded
                })
                this.isShowDetail = !this.isShowDetail;
            },0);
            this.loading = false;
        },
        async changeNewDatalist(val){
            this.loading = true
            await setTimeout(()=>{
                this.newDatalist = this.datalist.filter(item=>{
                    for( let i=0;i<val.length;i++){
                        if(item.billingCategoryName.split('-规')[0] == val[i])
                        return item
                    }
                })
                this.newDatalist.sort(this.dataSort)
            },0);
            this.loading = false
        },
        importExcel(){
            this.modalProps = {
                show: true,
                title: '导入数据',
                width:460,
                showFooter: false,
                action: process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingPriceTemplateItem/importItems",
                name: "excelFile",
                component: "compUpload",
                data: {
                    id:this.id,
                    templateCode: this.formData.code,
                    contextId: global.SYSID
                },
                download: () => {
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/newBilling/billingPriceTemplateItem/itemTemplate',{
                        id:this.id,
                        contextId: global.SYSID
                    },'download')
                },
                on:{
                    'on-success':(res)=>{
                        this.modalProps={},
                        this.update();
                    }
                }
            }
        },
        exportExcel() {
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingPriceTemplateItem/export", {templateCode:this.formData.code,version:this.formData.version}, 'download')
        },
        setStartTime(){
            if(this.startAllTime){
                this.newDatalist.map(item=>{
                    this.$set(item,'startTime',this.startAllTime)
                })
            }
        },
        setEndTime(){
            if(this.endAllTime){
                this.newDatalist.map(item=>{
                    this.$set(item,'endTime',this.endAllTime)
                })
            }
        },
        setValue(obj,attr,value){
            this.datalist.map(item => {
                if(item.billingCategoryCode == obj.billingCategoryCode){
                    this.$set(item,attr,value);
                }
            })
        },
        dataSort(a,b){
            if( a.billingCategoryName !== b.billingCategoryName ) return a.billingCategoryName < b.billingCategoryName ? -1 : 1
            if( !a.groupName || !b.groupName ){
                return -1
            }else{
                if( a.groupName !== b.groupName ) return a.groupName < b.groupName ? -1 : 1
                else if( a.code !== b.code ) return a.code < b.code ? -1 : 1
            }
        },
        handleCheckAll () {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;
            if (this.checkAll) {
                if(this.type == 'query'){
                    this.countDataList = this.countDataListQuery
                }else{
                    this.countDataList = this.countData.map(item=>{return item.label});
                    this.checkAllGroupChange(this.countDataList)
                }
            } else {
                this.countDataList = [];
            }
        },
        checkAllGroupChange(data){
            let ids = []
            this.dataName.map(item=>{
                data.map(json=>{
                    if(item.label == json){
                        ids.push(item.value)
                    }
                })
            })

            // 点击获取对应的计费id子节点
            HttpGetQuerySubByIds({ids}).then(res=>{

                this.datalist = res.data.map(item=>{
                    item.billingCategoryCode = item.code;
                    item.billingCategoryName = item.name;
                    item.billingCategoryFormula = item.formula;
                    item.billingCategoryId = item.id;
                    item.currentStatus = 0;
                    delete item.id
                    delete item.formula
                    return item
                })
                this.newDatalist = this.datalist
                console.log(res.data,'datadtatda')
            })
        },
        checkqueryAllGroupChange(data){
            if (data.length === this.countDataListQuery.length) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        getbillingUnit(num){
            return this.billUnitEnum.filter(item=>{ return item.value === num })[0].label || '--'
        },
        getbillConditionEnum(num){
            // console.log(num)
            if(num == 0){
                return '--'
            }else{
                let oneData = this.billConditionEnum.filter(item=>{ return item.value == num })
                if(oneData.length>0){
                    return oneData[0].label
                }else{
                    return '--'
                }
            }
        },
        update(){

            this.loading = true;
            this.$nextTick(() => {
                this.$refs.formbase.resetValidate();
            });
            HttpQueryReciveBase({
                    id:this.id,
            }).then(res=>{
                    this.formData = res.data;
                    this.formData.version = this.logversion;
                    HttpGetHistoryPriceItems({
                        templateCode:this.logcode,
                        version:this.logversion
                    }).then(res=>{
                        this.checkAll = this.type == 'query'?true:false;
                        this.datalist = res.data.map(item=>{
                            return item
                        })
                        this.newDatalist = this.datalist

                        // 作业费转换成其他数组形式
                        let obj = {};
                        this.datalist.forEach((item, index) => {
                            let { orderType } = item;
                            if (!obj[orderType]) {
                                obj[orderType] = {
                                    orderType,
                                    itemquery:'query',
                                    billingCategoryCode:'',
                                    billingCategoryName:'',
                                    billingUnit:'',
                                    description:'',
                                    groupName:'',
                                    billingCondition:'',
                                    billingCategoryFormula:'',
                                    price:'',
                                    minimumCharge:'',
                                    maximumCharge:'',
                                    childrenArr: [],
                                    _expanded:true
                                }
                            }
                            obj[orderType].childrenArr.push(item);
                        });
                        this.workDataList = Object.values(obj); // 最终输出

                        const dataName = res.data.map(item => {
                            return item.billingCategoryName.split('-规')[0]
                        });
                        this.countDataListQuery = dataName.filter( (item,index) => {
                            return dataName.indexOf(item) === index
                        })
                        this.countDataListQuery.sort()

                        this.countDataList = dataName.filter( (item,index) => {
                            return dataName.indexOf(item) === index
                        })

                        this.loading = false;
                    },err=>{
                        this.$Message.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    })
                    HttpGetCategoryType({expenseCategoryType:this.formData.expenseCategoryType,billingChannel:1}).then(res=>{
                        this.dataName = res.data.map(item => {
                            return {
                                label:item.name,
                                value:item.id
                            }
                        });
                        this.countData = this.dataName.filter( (item,index) => {
                            return this.dataName.indexOf(item) === index
                        })
                        this.countData.sort()
                        const selectedName = res.data.filter(item=> item.status == 1).map(item => {
                            return item.billingCategoryName.split('-规')[0]
                        });
                    })
                },err=>{
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
            })
        },
        async submit(params){
            const lastList = this.datalist.map(item=>{
                if(this.countDataList.indexOf(item.billingCategoryName.split('-规')[0]) > -1){
                    item.status = 1
                } else{
                    item.status = 0
                }

                return item
            })
            let flag = false
            await this.$refs.relation.validate(valid => {
                if (!valid) return flag = true
            })
            if (flag) return this.$Message.error('请填写必填项');

            let priceflag = false;
            // console.log(this.datalist,'this.datalist')
            // 判断填写了单价，当前行的日期必填
            for(let i=0;i<this.datalist.length;i++){
                if(this.datalist[i].price&&this.datalist[i].price!=0){
                    // console.log(this.datalist[i].price,this.datalist[i].startTime,this.datalist[i].endTime)
                    if(!this.datalist[i].startTime || !this.datalist[i].endTime){
                        priceflag = true
                    }
                }
            }
            if(priceflag){
                this.$Message.error('填写单价行的日期必填');
                return
            }
            this.loading = true;
            HttpSaveReciveTemplate({
                ...this.formData,
                priceTemplateItems:lastList
            }).then(res=>{
                this.$Message.success('保存成功');
                this.cancel()
                this.loading = false;
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.loading = false;
            })
        },

        cancel(){
            this.$router.push({
                name: 'tasksReceiveoffer',
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.other-form {
    .form-item {
        height: 42px;
        margin-bottom: 5px;
        clear: both;
    }
}
</style>

